import React, { useState, useEffect } from 'react';
import './SplashScreen.css';

const SPLASH_MIN_MS = 1500;
const FADE_MS = 300;

export default function SplashScreen({ onDone }) {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const hideAt = Date.now() + SPLASH_MIN_MS;
    const timer = setInterval(() => {
      if (Date.now() >= hideAt) {
        clearInterval(timer);
        setHidden(true);
      }
    }, 50);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (!hidden) return;
    const id = setTimeout(() => {
      onDone?.();
    }, FADE_MS);
    return () => clearTimeout(id);
  }, [hidden, onDone]);

  return (
    <div className={`splash-screen ${hidden ? 'splash-screen--hidden' : ''}`} aria-hidden="true">
      <div className="splash-screen-inner">
        <img
          src={`${process.env.PUBLIC_URL || ''}/KOSHA-logo.png`}
          alt="Kosha"
          className="splash-screen-logo"
        />
        <span className="splash-screen-text">Kosha</span>
      </div>
    </div>
  );
}
